import { Suspense } from "react";
import styled from "styled-components";

import Layer2 from "./Layer";
import useBIMClass from "../../../../../../clients/taxonomy/useBIMClass";
import useParameter from "../../../../../../clients/taxonomy/useParameter";
import * as UI from "../../../../../../modules/ui-kit";

const THICKNESS_PARAMETER_ID = "633afb41b2e8cb6b28aa847e";
const MATERIAL_TYPE_PARAMETER_ID = "633afb41b2e8cb6b28aa82c6";

const Styled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;
`;

export default function Layers(props) {
    const { bimClass: bimClassID, disabled, onChange, value } = props;

    const bimClass = useBIMClass(bimClassID);
    const materialTypeParameter = useParameter(MATERIAL_TYPE_PARAMETER_ID);

    if (!bimClass.data?.bimClass) return undefined;
    if (bimClass.data.bimClass.data.type !== "structure") return undefined;

    function addLayer() {
        const firstMaterialTypeValue = materialTypeParameter?.data?.parameter?.values?.[0]?.id;
        const newLayer = {
            properties: [
                {
                    __id: crypto.randomUUID(),
                    parameter: { id: MATERIAL_TYPE_PARAMETER_ID },
                    value: firstMaterialTypeValue,
                },
                {
                    __id: crypto.randomUUID(),
                    parameter: { id: THICKNESS_PARAMETER_ID },
                    unit: "mm",
                    value: 1,
                },
            ],
        };
        onChange([...value, newLayer]);
    }

    function makeMove(i: number, step: number) {
        const [a, b] = step > 0
            ? [0, 1]
            : [-1, 0];
        return function move() {
            const reordered = [...value];
            [
                reordered[i + a],
                reordered[i + b],
            ] = [
                reordered[i + b],
                reordered[i + a],
            ];
            onChange(reordered);
        };
    }

    function update(layer, update) {
        /*
        Add component
         */
        if (!layer) {
            onChange([...value, update]);
            return;
        }

        /*
        Remove component
         */
        if (!update) {
            onChange(
                value.toSpliced(
                    value.indexOf(layer),
                    1,
                )
            );
            return;
        }

        /*
        Change component
         */
        onChange(
            value.with(
                value.indexOf(layer),
                {
                    ...layer,
                    ...update,
                },
            )
        );
    }

    return (
        <Styled>
            <span>TOP - EXTERIOR</span>
            {
                value.map(
                    (layer, i) => (
                        <Suspense key={ i }>
                            <Layer2
                                bimClassID={ bimClassID }
                                componentTypeID={ layer.componentType?.id }
                                index={ i }
                                onChange={ (updateSpec) => update(layer, updateSpec) }
                                onCopy={
                                    (newLayerData) => {
                                        const arrayCopy = [...value];
                                        arrayCopy.splice(
                                            i + 1,
                                            0,
                                            { ...newLayerData, __id: crypto.randomUUID() },
                                        );
                                        onChange(arrayCopy);
                                    }
                                }
                                onMoveDown={ i === value.length - 1 ? undefined : makeMove(i, 1) }
                                onMoveUp={ i === 0 ? undefined : makeMove(i, -1) }
                                onRemove={ () => update(layer, undefined) }
                                properties={ layer.properties }
                            />
                        </Suspense>
                    )
                )
            }
            <span>BOTTOM - INTERIOR</span>
            <UI.Button
                disabled={ disabled }
                onClick={ addLayer }
            >
                add layer
            </UI.Button>
        </Styled>
    );
}
